// Barra de chips para filtrar un feed por categoría. Compartida por el timeline
// del lead (LeadTimeline) y el historial del ticket (TicketDetail), que tienen
// categorías distintas pero el mismo comportamiento y aspecto.
//
// El contador de la derecha muestra `mostradas / cargadas` mientras hay filtro
// activo: los feeds filtran en cliente sobre lo ya paginado, y sin ese dato el
// usuario no distingue "no hay" de "no hay todavía".

export type CategoryChipOption<T extends string> = {
  key: T;
  label: string;
};

export default function CategoryChipBar<T extends string>({
  options,
  value,
  onChange,
  shown,
  total,
  allKey,
  ariaLabel = "Filtrar actividad",
}: {
  options: CategoryChipOption<T>[];
  value: T;
  onChange: (next: T) => void;
  shown: number;
  total: number;
  /** Clave del chip "todos"; con ella activa no se muestra el desglose. */
  allKey: T;
  ariaLabel?: string;
}) {
  return (
    <div style={categoryBar} role="tablist" aria-label={ariaLabel}>
      {options.map((o) => {
        const active = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(o.key)}
            style={{ ...categoryChip, ...(active ? categoryChipActive : {}) }}
          >
            {o.label}
          </button>
        );
      })}
      <span style={categoryCount}>
        {shown}
        {value !== allKey && ` / ${total}`}
      </span>
    </div>
  );
}

const categoryBar: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "0.25rem",
  margin: "0.5rem 0 0.6rem",
};

const categoryChip: React.CSSProperties = {
  padding: "0.15rem 0.5rem",
  borderRadius: "999px",
  fontSize: ".72rem",
  fontWeight: 600,
  border: "1px solid #dee2e6",
  background: "white",
  color: "#73879C",
  cursor: "pointer",
};

const categoryChipActive: React.CSSProperties = {
  background: "#1f2933",
  color: "white",
  border: "1px solid #1f2933",
};

const categoryCount: React.CSSProperties = {
  marginLeft: "auto",
  fontSize: ".68rem",
  color: "#adb5bd",
};
